import '../../App.css'

import React, { useEffect, useState } from 'react'
import { useAuth } from '../../contexts/AuthContext.js'
import { collection, getDocs } from '@firebase/firestore'
import { db } from '../../firebase/firebase.js'
import './UserData.css'


const UserData = () => {
    const [documents, setDocuments] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [searchTerm, setSearchTerm] = useState("");
    const [inputValue, setInputValue] = useState("");

    const [sortField, setSortField] = useState(null);
    const [sortDirection, setSortDirection] = useState("asc");



    useEffect( () => {
        const fetchDocuments = async () => {
            setIsLoading(true)
            try{
                const snapshot = await getDocs(collection(db, "Users"))
                const allDocs = snapshot.docs.map(doc => ({id: doc.id,  ...doc.data()}))
                let filtered = allDocs
         
                if(searchTerm.trim() !== ''){
                    filtered = allDocs.filter( doc =>
                        doc.firstName?.toLowerCase().includes(searchTerm) ||
                        doc.lastName?.toLowerCase().includes(searchTerm) ||
                        doc.email?.toLowerCase().includes(searchTerm) ||   doc.abstracts?.[0]?.name.toLowerCase().includes(searchTerm)
                    )
                }
                
                if(sortField){
                    filtered = [...filtered].sort((a, b) => {
                        let aVal
                        let bVal
                        if(sortField == 'admin' || sortField == 'sculc_presenter' || sortField == "sculc_applicant"){
                            aVal = a[sortField] === true ? 1 : 0
                            bVal = b[sortField] === true ? 1 : 0
                            return sortDirection === 'asc' ? bVal - aVal : aVal - bVal;
                        }

                        if (sortField === 'uploadedAt') {
                            aVal = new Date(a.abstracts?.[0]?.uploadedAt || 0).getTime()
                            bVal = new Date(b.abstracts?.[0]?.uploadedAt || 0).getTime()

                            if(aVal == 0 && bVal != 0) return 1
                            if(aVal != 0 && bVal == 0) return -1
                            if(aVal == 0 && bVal == 0) return 0
                          
                            return sortDirection === 'asc' ? aVal - bVal: bVal - aVal;
                          }

                        if(sortField == 'abstractName'){
                            aVal = a.abstracts?.[0]?.name?.toLowerCase() || ''
                            bVal = b.abstracts?.[0]?.name?.toLowerCase() || ''
                            if(aVal == '' && bVal != '') return 1;
                            if(aVal != '' && bVal == '') return -1;
                            if(aVal == '' && bVal == '') return 0;


                            return sortDirection === 'asc' ? aVal.localeCompare(bVal) : bVal.localeCompare(aVal)
                        }

                        aVal = a[sortField]?.toString().toLowerCase() || ''
                        bVal = b[sortField]?.toString().toLowerCase() || ''
                        if(aVal == '' && bVal != '') return 1;
                        if(aVal != '' && bVal == '') return -1;
                        if(aVal == '' && bVal == '') return 0;
                        return sortDirection === 'asc' ? aVal.localeCompare(bVal) : bVal.localeCompare(aVal)
                    })
                }
                setDocuments(filtered)


            } catch (error) {
                console.error("Error fetching documents: ", error)
            }
            setIsLoading(false);

        }
        fetchDocuments();
    }, [searchTerm, sortField, sortDirection]);


    const handleKeyDown = (e) =>{
        if(e.key == 'Enter'){
            setSearchTerm(inputValue?.toLowerCase());
        }

    }

    const handleSort = (field) => {
        if(sortField === field){
            setSortDirection(prev => (prev === "asc" ? "desc" : "asc"));
        } else {
            setSortField(field)
            setSortDirection("asc")
        }
    }

    return (

        <div style={ {paddingLeft: "20px", paddingRight: "20px"}}>
            {isLoading ? null : (
            <div>
                <div style={{ display: 'flex', justifyContent: 'flex-start' , padding: "10px"}}>
                <input
                    style={{width: '30%'}}
                    align='left'
                    type="text"
                    value={inputValue}
                    onChange={(e) => setInputValue(e.target.value)}
                    onKeyDown={handleKeyDown}>
                </input>
                </div>
            <table>
                <thead>
                    <tr>
                        <th className='headText' onClick={() => handleSort('firstName')}>Name</th>
                        <th className='headText' onClick={() => handleSort('email')}>Email</th>
                        <th className='headText' onClick={() => handleSort('sculc_applicant')}>Applicant</th>
                        <th className='headText' onClick={() => handleSort('sculc_presenter')}>Presenter</th>
                        <th className='headText' onClick={() => handleSort('abstractName')}>Abstract Name</th>
                        <th className='headText' onClick={() => handleSort('uploadedAt')}>Upload Time</th>
                        <th className='headText' onClick={() => handleSort('admin')}>Admin</th>
                    </tr>
                </thead>
                <tbody>
                    {documents.map(doc => (
                       <tr key={doc.id}>
                            <td>{doc.firstName} {doc.lastName}</td>
                            <td>{doc.email} </td>
                            <td>{doc.sculc_applicant ? "Yes" : "No" }</td>
                            <td>{doc.sculc_presenter ? "Yes" : "No" }</td>
                            <td>{doc.abstracts?.[0] ?
                                ( <a href={doc.abstracts[0].url}
                                    >{doc.abstracts[0].name}
                                    </a>)  : " " }</td>
                            <td> {doc.abstracts?.[0]? 
                                    new Date(doc.abstracts[0].uploadedAt).toLocaleString() 
                                    : " "}</td>
                            <td>{doc.admin? "Yes" : "No"}</td>

                       </tr>
                    ))}

                </tbody>
            </table>   
            </div>
            )}
        </div>
    )
}

export default UserData